import { state } from "__common/store";
import { applyMlpeComboClampRailClampChanges } from "__common/utils/versionCompare/versionCompare";

export const STANDARD_CLAMPS = {
  type: 'Standard Clamps',
  number: 'STDCLAMPS',
};

export const MID_CLAMP = {
  type: 'Mid Clamp',
};

export const END_CLAMP = {
  type: 'End Clamp',
};

export const NXT_CLAMP_TYPE = {
  type: 'Universal Clamp',
}

export const NXT_HIDDEN_END_CLAMP_TYPE = {
  type : 'Hidden End Clamp'
}

export const PART_RM10_EVO_MODULE_CLAMP_KIT = '370020'
export const PART_RM10_EVO_MODULE_CLAMP_SIDE_BOLT_BULK = '370022'
export const PART_RM10_EVO_MODULE_CLAMP_BULK = '370023'
export const MICRO_INVERTER_MOUNTING_TO_MODULE_FRAME = "008114M"
export const MICRO_MNT_BND_TBOLT_SS = '008013S'
export const MLPE_MOUNT_ASSY = "008114M"
export const MLPE_TIGER_CLIP = "008115M"
export const BND_T_BOLT_NUT_3_8_3_4_SS = '009021S'
export const BND_T_BOLT_NUT_3_8_1_SS = '009020S'
const NEW_NXT_MLPE_LUG_CLAMP_FOR_LUG = 'LUGMLPE2'
const NXT_MLPE_LUG_CLAMP_FOR_LUG = 'LUGMLPE1'
export const NEW_NXT_MLPE_LUG_CLAMP_FOR_LUG_V1 = 'NULGMLP1'
export const NEW_NXT_MLPE_AND_GND_LUG_DOMESTIC = 'NULGMLP1-US'
export const RM_ROOF_PAD_DOMESTIC = '310760-US'
export const RM_ROOF_PAD = '310760'
export const UGARD_M5 = 'GUARD-M5'
export const UGARD_M6 = 'GUARD-M6'
export const UGARD_M8 = 'GUARD-M8'
export const UGARD_CLP = 'GUARD-CLP'
export const FLASHLOC_ANCHOR_SEALANT_FREE = '004FLAN'
export const FLASHLOC_ANCHOR_REG_SEALANT = '004FLAN-R'
export const FLASHLOC_ANCHOR_FOR_SILICONE = '004FLAN-S'
export const FLASHLOC_RM_KIT = '310999'
export const FLASHLOC_COMP_KIT_MILL = '004085M'
export const FLASHLOC_COMP_KIT_DARK = '004085D'
export const STRONGHOLD_ATT_COMP_MILL = 'SHCPKTM1'
export const STRONGHOLD_ATT_COMP_DARK = 'SHCPKTD1'
export const ILSO_LAY_IN_LUG = '008009P'
export const U_LUG='U-LUG'

export const TILT_LEG_LFOOT_PARTS = [ "A1LF01M", "A1LF02M", "304001C", "304001D", "307004M", "307005M", "307006M", "307012M", "307014M" ];

export const FLASHLOC_PARTS = [FLASHLOC_ANCHOR_SEALANT_FREE, FLASHLOC_ANCHOR_REG_SEALANT, FLASHLOC_ANCHOR_FOR_SILICONE];

export const mlpePartNumber = () => {
  const { projectConfiguration: { projectVersion } } = state();
  return applyMlpeComboClampRailClampChanges(projectVersion) ? NEW_NXT_MLPE_LUG_CLAMP_FOR_LUG: NXT_MLPE_LUG_CLAMP_FOR_LUG;
}

export const SOLOBOX_AND_CONDUIT_MOUNT_PARTS = ["CMBTLM1"];
export const SM_168_PARTS = ["320168M", "310168D", "310168C"];
export const SM_208_PARTS = ["320208M", "310208C"];
export const S5_ATTACHMENT_PARTS = ['S-5-H', 'S-5-H Mini', 'S-5-MX', 'S-5-MX Mini', 'S-5-N', 'S-5-N 1.5', 'S-5-N 1.5 Mini', 
                                                  'S-5-N Mini', 'S-5-NH 1.5', 'S-5-NH 1.5 Mini', 'S-5-S', 'S-5-S Mini', 'S-5-U', 'S-5-U Mini']

export const PARTS_BELONG_FOR_PACK_NOTE = [
  {partNumber: FLASHLOC_RM_KIT, suggested_pack : 10},
  {partNumber: FLASHLOC_COMP_KIT_MILL, suggested_pack : 20},
  {partNumber: FLASHLOC_COMP_KIT_DARK, suggested_pack : 20},
  {partNumber: STRONGHOLD_ATT_COMP_MILL, suggested_pack : 20},
  {partNumber: STRONGHOLD_ATT_COMP_DARK, suggested_pack : 20},
  {partNumber: ILSO_LAY_IN_LUG, suggested_pack : 20},


]

export const partToPackMap = PARTS_BELONG_FOR_PACK_NOTE.reduce((acc, item) => {
  acc[item.partNumber] = item.suggested_pack;
  return acc;
}, {});

export function isDomesticPart(part){
  const splitPart = part.split("-");
  return splitPart.length > 1 && splitPart[splitPart.length - 1].toUpperCase() === "US";
}
